module.exports = __webpack_public_path__ + "img/q_25_sor.61b82ab0.png";